import apiClient from "../../utils/interceptor"
import { ApiResponse, CompanyData, CreateCompanyParams, CreateCompanyResponse, UpdateCompanyParams, CompanyScanCount } from "./interface";
import { API_URLS } from "../../constants";

// Function to get all companies
export const getAllCompanies = async (): Promise<ApiResponse<CompanyData[]>> => {
    try {
        const response = await apiClient.get<ApiResponse<CompanyData[]>>(
            API_URLS.COMPANY.GET_COMPANIES,
        );     
        return response.data;
    } catch (error) {
        console.error("Error fetching companies:", error);
        throw error;
    }
};

// Function to create a company
export const createCompany = async (
    companyParams: CreateCompanyParams
): Promise<ApiResponse<CreateCompanyResponse>> => {
    try {
        const response = await apiClient.post<ApiResponse<CreateCompanyResponse>>(
            API_URLS.COMPANY.CREATE_COMPANY,
            companyParams,
        );
        return response.data;
    } catch (error) {
        console.error("Error creating company:", error);
        throw error;
    }
};

// Function to update a company
export const updateCompany = async (
    companyData: UpdateCompanyParams
): Promise<ApiResponse<null>> => {
    try {
        const response = await apiClient.patch<ApiResponse<null>>(
            API_URLS.COMPANY.UPDATE_COMPANY,
            companyData,
        );
        return response.data;
    } catch (error) {
        console.error("Error updating company:", error);
        throw error;
    }
};

// Function to delete a company
export const deleteCompany = async (
    companyId: string
): Promise<ApiResponse<null>> => {
    try {
        const response = await apiClient.delete<ApiResponse<null>>(
            `${API_URLS.COMPANY.DELETE_COMPANY}`,
            {
                data: { company_id: companyId }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting company:", error);
        throw error;
    }
};

export const getCompanyWiseScanCount = async (): Promise<ApiResponse<CompanyScanCount[]>> => {
    try {
        const response = await apiClient.get<ApiResponse<CompanyScanCount[]>>(
            API_URLS.COMPANY.GET_COMPANY_WISE_SCAN_COUNT,
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching company wise scan count:", error);
        throw error;
    }
};